import React from "react";

interface BlankSlateProps {
    children: React.ReactNode;
}

export const BlankSlate: React.FC<BlankSlateProps> = props => {
    return (
        <div className="rounded border border-dashed border-gray-300 px-4 py-6 text-center text-sm text-gray-500">
            {props.children}
        </div>
    );
};
